import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from "../../../../../../core/service/v2/abstractRepositoryV2";
import {PaymentRequestReminderModel} from "../../api/entity/paymentRequestReminder.model";

@Injectable()
export class PaymentRequestReminderRepository extends AbstractRepositoryV2<PaymentRequestReminderModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('PaymentRequestReminder', serviceElementsFactory, injector);
    }
}
